import portalApiClient from '@/services/PortalClient'

export default {
  loginByUsername (username) {
    return portalApiClient.sendUnauthorizedRequest(
      'POST',
      'internalapi/v2/admin/login',
      { username }
    )
  },
  loginByOAuthToken (idToken) {
    return portalApiClient.sendUnauthorizedRequest(
      'POST',
      'admin/api/v2/login',
      { idToken }
    )
  },
  fetchOnboarders () {
    return portalApiClient.sendRequest(
      'GET',
      'admin/api/v1/employees?onboarder=true'
    )
  },
  getCurrentAdmin () {
    return portalApiClient.sendUnauthorizedRequest(
      'GET',
      'admin/api/v2/admins/current'
    )
  },
  selectLicense (license) {
    return portalApiClient.sendRequest(
      'POST',
      `admin/api/v2/admins/license`,
      { license }
    )
  },
  logout () {
    return portalApiClient.sendUnauthorizedRequest(
      'POST',
      'admin/api/v2/logout'
    )
  }
}
